export const APP_ENV = process.env.REACT_APP_ENV;
export const [APP, ENV] = APP_ENV.match(/(.+)_(.+)$/).slice(1);
export const API_URL = process.env.REACT_APP_API_URL;
export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
export const DEFAULT_THEME_COLOR = process.env.REACT_APP_DEFAULT_THEME_COLOR || '#0CA58B';
export const MATOMO_SITE_ID = process.env.REACT_APP_MATOMO_SITE_ID;
export const EVENT_REGISTER_START_TIME = process.env.REACT_APP_EVENT_REGISTER_START_TIME;
export const EVENT_REGISTER_END_TIME = process.env.REACT_APP_EVENT_REGISTER_END_TIME;
export const FIREBASE_API_URL = process.env.REACT_APP_FIREBASE_API_URL;
export const EVENT_CONFIGS_API_URL = `${process.env.REACT_APP_FIREBASE_API_URL}/events`;
export const FIRST_VISIBLE_ROUTES = JSON.parse(process.env.REACT_APP_FIRST_VISIBLE_ROUTES);
// eslint-disable-next-line no-eval
export const ACL = (context, item) => { if (item === 'landing') return !context.authToken; return !!context.authToken; };

export const FETCH_ASSETS_URL = process.env.REACT_APP_FETCH_ASSETS_URL;
export const FETCH_PRODUCT_URL = process.env.REACT_APP_FETCH_PRODUCT_URL;
export const FETCH_CACHED_CMS_DATA_URL = process.env.REACT_APP_FETCH_CACHED_CMS_DATA_URL;
export const FETCH_CACHED_EVENT_CONFIGS_API_URL = process.env.REACT_APP_FETCH_CACHED_EVENT_CONFIGS_API_URL;

export const VIDEO_CALL_URL = process.env.REACT_APP_VIDEO_CALL_URL;
export const LOCALHOST_DOMAIN = process.env.REACT_APP_LOCALHOST_DOMAIN || 'virtual.2vanx.com';
export const APP_DOMAIN = window.location.hostname === 'localhost' ? LOCALHOST_DOMAIN : window.location.hostname;
export const ZOOM_HOSTING_ENDPOINT = process.env.REACT_APP_ZOOM_ENDPOINT;
export const HKTDC_PARTICIPANTS_API_URL = process.env.REACT_APP_HKTDC_PARTICIPANTS_API_URL;
export const ZENDESK_ID = process.env.REACT_APP_ZENDESK_ID;
export const CLOUDFLARE_TRACE_URL = process.env.REACT_APP_CLOUDFLARE_TRACE_URL;
export const AVAILABLE_LOCALES = JSON.parse(process.env.REACT_APP_AVAILABLE_LOCALES || null) || ['en', 'ja', 'id-ID', 'zh-Hans', 'zh-Hant', 'ko', 'ru'];
export const ONESKY_LOCALE_MAPPING = JSON.parse(process.env.REACT_APP_ONESKY_LOCALE_MAPPING || null) || {
  en: 'en',
  'id-ID': 'id',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hant': 'zh-HK',
  ja: 'ja',
  ko: 'ko',
  es: 'es',
  fr: 'fr',
  vi: 'vi',
  ru: 'ru',
};
export const ONESKY_API_KEY = process.env.REACT_APP_ONESKY_API_KEY;
export const ONESKY_SECRET_KEY = process.env.REACT_APP_ONESKY_SECRET_KEY;
export const ONESKY_PROJECT_ID = process.env.REACT_APP_ONESKY_PROJECT_ID;
export const ONESKY_SOURCE_FILE_NAME = process.env.REACT_APP_ONESKY_SOURCE_FILE_NAME;
export const WEBINARS_API_URL = `${process.env.REACT_APP_FIREBASE_API_URL}/webinars`;
export const LIVESTREAM_API_URL = process.env.REACT_APP_LIVESTREAM_API_URL;
export const LIVESTREAM_REALTIMEDB_API_URL = process.env.REACT_APP_LIVESTREAM_REALTIMEDB_API_URL;
export const LIVESTREAM_TIMESTAMP_UPDATE_INTERVAL = parseInt(process.env.REACT_APP_LIVESTREAM_TIMESTAMP_UPDATE_INTERVAL, 10);
export const LIVESTREAM_TIMESTAMP_MAX_WAIT = LIVESTREAM_TIMESTAMP_UPDATE_INTERVAL + 20 * 1000;
// Reference: https://dash.cloudflare.com/65b5db0825f71dbcef445077a0c8c654/workers/view/eventx-proxy-worker
export const PROXY_WORKER_URL = process.env.REACT_APP_PROXY_WORKER_URL;

export const SPLITIO_API_KEY = process.env.REACT_APP_SPLITIO_API_KEY;
export const CHAT_API_URL = process.env.REACT_APP_CHAT_API_URL;

export const AGORA_APP_ID = process.env.REACT_APP_AGORA_APP_ID;
export const REPORT_API_KEY = process.env.REACT_APP_REPORT_API_KEY;
export const REPORT_AUTH_DOMAIN = process.env.REACT_APP_REPORT_AUTH_DOMAIN;
export const REPORT_DATABASE_URL = process.env.REACT_APP_REPORT_DATABASE_URL;
export const REPORT_PROJECT_ID = process.env.REACT_APP_REPORT_PROJECT_ID;
export const REPORT_STORAGEBUCKET = process.env.REACT_APP_REPORT_STORAGEBUCKET;
export const REPORT_MESSAGING_SENDER_ID = process.env.REACT_APP_REPORT_MESSAGING_SENDER_ID;
export const REPORT_APP_ID = process.env.REACT_APP_REPORT_APP_ID;
export const HOTJAR_ID = process.env.REACT_APP_HOTJAR_ID;
export const HOTJAR_SURVEY_VERSION = process.env.REACT_APP_HOTJAR_SURVEY_VERSION;
export const SENTRY_RELEASE_VERSION_NUMBER = process.env.REACT_APP_SENTRY_RELEASE_VERSION_NUMBER;
export const VEXPO_LIVE_STREAM_URL = process.env.REACT_APP_VEXPO_LIVE_STREAM_URL;
export const NETWORKING_LOUNGE_API_URL = process.env.REACT_APP_NETWORKING_LOUNGE_API_URL;
export const MEETING_APP_URL = process.env.REACT_APP_MEETING_APP_URL;

export default {
  APP_ENV,
  API_URL,
  MATOMO_SITE_ID,
  ACL,
  ZENDESK_ID,
  AVAILABLE_LOCALES,
  ONESKY_API_KEY,
  ONESKY_SECRET_KEY,
  ONESKY_PROJECT_ID,
  ONESKY_SOURCE_FILE_NAME,
  SPLITIO_API_KEY,
  WEBINARS_API_URL,
  LIVESTREAM_API_URL,
  LIVESTREAM_REALTIMEDB_API_URL,
  REPORT_API_KEY,
  REPORT_AUTH_DOMAIN,
  REPORT_DATABASE_URL,
  REPORT_PROJECT_ID,
  REPORT_STORAGEBUCKET,
  REPORT_MESSAGING_SENDER_ID,
  REPORT_APP_ID,
  HOTJAR_ID,
  HOTJAR_SURVEY_VERSION,
  SENTRY_RELEASE_VERSION_NUMBER,
  VEXPO_LIVE_STREAM_URL,
};
